<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item :link="{
            name: 'Enterprise Dashboard',
            icon: 'fas fa-tachometer-alt text-black',
            path: '/enterprise/dashboard'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Enterprise Users',
            icon: 'fas fa-users text-black',
            path: '/enterprise/users'
          }"
        ></sidebar-item>
      </template>

      <template slot="links-after">
        <hr class="my-3" v-if="portalAccess">
        <b-nav class="navbar-nav mb-md-3">
          <sidebar-item :link="{
              name: 'Back to ClarityNOW',
              icon: 'fas fa-home text-black',
              path: '/home'
            }"
          ></sidebar-item>
          <sidebar-item :link="{
              name: 'Account Settings',
              icon: 'fas fa-cog text-black',
              path: '/account-settings'
            }"
          ></sidebar-item>
        </b-nav>
      </template>
    </side-bar>
    <div class="main-content">
      <enterprise-navbar :type="$route.meta.navbarType"></enterprise-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import EnterpriseNavbar from './EnterpriseNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      EnterpriseNavbar,
      ContentFooter,
      FadeTransition,
    },
    data() {
      return {
        portalRoles: ['owner', 'agent']
      }
    },
    computed: {
      user() {
        return this.$store.getters['profile/user'];
      },
      role() {
        return this.$store.getters['roles/roles'][0];
      },
      owner() {
        return this.role == 'owner';
      },
      portalAccess() {
        return this.portalRoles.includes(this.role);
      },
      active() {
        return this.portalAccess && this.user.setup_complete;
      },
      observatory() {
        return this.$route.meta.observatory;
      },
      observatoryPath() {
        return '/observatory/' + this.$route.params.user;
      },
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
</style>
